import { Button } from "@components/Button";
import {
  MAX_LANDING_PAGE_SECTION_WIDTH,
  SECTION_WIDTH_VAR,
} from "@components/layout/PageSection";
import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { spacing } from "@every.org/common/src/display/spacing";

import { darkBgThemeCss, lightBgThemeNoBgCss } from "src/theme/color";

const SEE_RECENT_DONATIONS_BUTTON_HEIGHT = "56px";

export const defaultPageLayoutCss = [
  darkBgThemeCss,
  css`
    ${SECTION_WIDTH_VAR}: ${MAX_LANDING_PAGE_SECTION_WIDTH};
  `,
];

export const defaultPageLayoutFooterCss = css`
  margin-top: 0;
`;

export const pageSectionCss = css`
  height: calc(100% - ${SEE_RECENT_DONATIONS_BUTTON_HEIGHT});
  padding-top: ${spacing.m};
  padding-bottom: ${spacing.m};

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LandingSeeRecentDonationsButtonsSection = styled.section`
  ${lightBgThemeNoBgCss};
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0;
  display: flex;
  gap: ${spacing.m};
  flex-direction: column;
  align-items: center;
`;

export const LandingSeeRecentDonationsButton = styled(Button)`
  height: ${SEE_RECENT_DONATIONS_BUTTON_HEIGHT};
  width: 100%;
  border-radius: 0;
  padding: ${spacing.xs} 0;
`;

export const landingFeedPageSectionCss = css`
  padding-top: ${spacing.xxl};
`;
